export default __webpack_public_path__ + "static/media/trr-drink-bottle-redstripe.0e4d4ee8.png";